import type { EndpointDefinition } from "../../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    previewUpcomingInvoiceForBillingInterval: {
        route: "/workspaces/:workspaceId/billing/invoices/preview/billing-interval",
        method: "GET"
    },
    previewInvoicesForQuantity: {
        route: "/workspaces/:workspaceId/billing/invoices/preview/quantity",
        method: "GET"
    },
    payLatestInvoiceOnPastDueSubscription: {
        route: "/workspaces/:workspaceId/billing/subscriptions/pay-latest-invoice",
        method: "POST"
    }
};
